import React, { useMemo } from 'react';

import Chapter from '../../Chapter';
import ActivityCarouselScene, { calculateDuration } from './ActivityCarouselScene';
import ActivitiesChapterI from './ActivityChapter.interface';
import { getEntries } from './helpers';

export default class ActivityChapter extends Chapter<ActivitiesChapterI> {
    component = () => {
        const entries = useMemo(() => getEntries(this.data), []);

        return (
            <ActivityCarouselScene
                {...this.data}
                entries={entries}
            />
        );
    };

    calculateDuration() {
        return calculateDuration(this.data, this.lockedSectionIdx) || 0;
    }
}
